import type { FilterStorageId, FilterStorageOptions, SessionResource } from './types';

export class SessionFilterStorage {
  entryId: string;
  featureName: string;
  resourceId: string;
  storage: SessionResource;

  /**
   * Session storage that is configured to save filter object
   */
  constructor({
    featureName = '',
    filterEntityOptions = {},
    sessionStore,
    resourceId,
    entryId,
  }: FilterStorageOptions = {}) {
    if (!sessionStore) {
      throw new Error('No session store is provided');
    }
    this.featureName = featureName;

    if (resourceId) {
      this.resourceId = resourceId;
    } else {
      this.resourceId = this.getSessionStorageId({
        featureName,
        entityName: filterEntityOptions.entitySchema.name,
      }).resourceId;
    }

    if (entryId) {
      this.entryId = entryId;
    } else {
      this.entryId = this.getSessionStorageId({
        featureName,
        entityName: filterEntityOptions.entitySchema.name,
      }).entryId;
    }

    if (!sessionStore.definitions[this.resourceId]) {
      sessionStore.defineResource(this.resourceId);
    }

    this.storage = sessionStore.definitions[this.resourceId];
  }

  // eslint-disable-next-line no-unused-vars
  getSessionStorageId(options?: { featureName?: string; entityName?: string }): FilterStorageId {
    throw new Error('Not implemented');
  }

  // eslint-disable-next-line no-unused-vars
  save(...args: any[]): any {
    throw new Error('Not implemented');
  }

  get(): any {
    throw new Error('Not implemented');
  }

  clean() {
    return this.storage.destroy(this.entryId);
  }
}
